<template>
    <ul v-if="pages_count <= 15" class="pagination">
        <li v-for="e in pages_count" :key="e">
            <btn :active="e === current_page" @click="changePage(e)">
                {{ e }}
            </btn>
        </li>
    </ul>

    <ul v-else class="pagination">
        <template v-if="current_page >= 9">
            <li>
                <btn @click="changePage(1)">1</btn>
            </li>
            <li>...</li>
            <li v-if="pages_count - current_page <= 6 && pages_count - current_page > 4" v-for="(e, i) in 12">
                <btn v-if="current_page - 5 + i <= pages_count" :active="current_page - 5 + i === current_page" @click="changePage(current_page - 5 + i)">
                    {{ current_page - 5 + i}}
                </btn>
            </li>

            <li v-if="pages_count - current_page <= 6 && pages_count - current_page <= 4" v-for="(e, i) in 10" :key="e">
                <btn :active="pages_count - 9 + i === current_page" @click="changePage(pages_count - 9 + i)">
                    {{ pages_count - 9 + i}}
                </btn>
             </li>
        </template>

        <li v-if="current_page < 9" v-for="e in midleBtnCount" :key="e">
            <btn :active="e === current_page" @click="changePage(e)">
                {{ e }}
            </btn>
        </li>

        <li v-if="current_page >= 9 && pages_count - current_page > 6" v-for="(e, i) in 10" :key="e">
            <btn :active="current_page - 5 + i === current_page" @click="changePage(current_page - 5 + i)">
                {{ current_page - 5 + i}}
            </btn>
        </li>

        <template v-if="pages_count - current_page > 6">
            <li>...</li>
            <li>
                <btn :active="pages_count === current_page" @click="changePage(pages_count)">
                    {{ pages_count }}
                </btn>
            </li>
        </template>
    </ul>
</template>

<script>
import btn from '@/components/ui/oldPagination/paginationBtn.vue.js'

export default {
    props: {
        paginationObj: {
            type: Object,
            default:  null
        },
        getNewContent: {
            type: Function,
            default: () => {}
        }
    },
    components: { btn },
    data() {
        return {
            current_page: this.paginationObj?.current_page || 1
        }
    },
    computed: {
        midleBtnCount() {
            switch(true) {
                case this.current_page < 7:
                    return 10
                case this.current_page === 7:
                case this.current_page === 8:
                    return this.current_page + 4
            }
        },
        pages_count() { return this.$props.paginationObj?.pages_count }
    },
    methods: {
        changePage(page) {
            this.current_page = page
            const { rows_per_page } = this.$props.paginationObj
            const offset = (page - 1) * rows_per_page
            this.$props.getNewContent(rows_per_page, offset)
        }
    },
    watch: {
        paginationObj() { this.current_page = this.$props.paginationObj?.current_page || 1 }
    }
}
</script>

<style lang="sass" scoped>
.pagination
    max-width: 70%
    padding: 0
    margin: 0
    display: inline
    li
        display: inline

</style>